export default {
  height:'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchMenuSpan: 6,
  border: true,
  index: true,
  viewBtn: true,
  selection: true,
  dialogClickModal: false,
  column: [
    {
      label: "",
      prop: "id",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "客户档案id",
      prop: "loanInformationId",
      type: "input",
    },
    {
      label: "婚姻状态",
      prop: "maritalStatus",
      type: "input",
    },
    {
      label: "配偶姓名",
      prop: "spouseName",
      type: "input",
    },
    {
      label: "配偶年收入",
      prop: "spouseEarnings",
      type: "input",
    },
    {
      label: "配偶单位",
      prop: "spouseCompany",
      type: "input",
    },
    {
      label: "是否有子女",
      prop: "childStatus",
      type: "input",
    },
    {
      label: "子女个数",
      prop: "childCount",
      type: "input",
    },
    {
      label: "子女状态",
      prop: "childDescription",
      type: "input",
    },
    {
      label: "所属行业",
      prop: "workIndustry",
      type: "input",
    },
    {
      label: "工作年限",
      prop: "workYear",
      type: "input",
    },
    {
      label: "职务",
      prop: "workPost",
      type: "input",
    },
    {
      label: "额外年收入",
      prop: "extraEarnings",
      type: "input",
    },
    {
      label: "公司年限",
      prop: "companyYear",
      type: "input",
    },
    {
      label: "公司规模",
      prop: "companySize",
      type: "input",
    },
    {
      label: "信用卡额度",
      prop: "creditCardLimit",
      type: "input",
    },
    {
      label: "信用卡数量",
      prop: "creditCardCount",
      type: "input",
    },
    {
      label: "信贷金额",
      prop: "creditLoanAmount",
      type: "input",
    },
    {
      label: "房贷金额",
      prop: "houseLoanAmount",
      type: "input",
    },
    {
      label: "日常支出",
      prop: "dailyExpenses",
      type: "input",
    },
    {
      label: "其他负债",
      prop: "otherLoanAmount",
      type: "input",
    },
    {
      label: "备注",
      prop: "remark",
      type: "input",
    },
    {
      label: "",
      prop: "tenantId",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建人",
      prop: "createUser",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建部门",
      prop: "createDept",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "修改人",
      prop: "updateUser",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "修改时间",
      prop: "updateTime",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "打款状态 1.未打款 2.已打款",
      prop: "status",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: "是否已删除",
      prop: "isDeleted",
      type: "input",
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
  ]
}
